// extracted by mini-css-extract-plugin
module.exports = {"card-header":"CardHeader_card-header__1R1fR"};